<div class="form-group">
  <div
    class="modalInput__input-wrapper advancedCFAccess__email-input"
    (click)="focusInput()"
    ppTooltip
    [ppTitle]="ppDisabled ? '' : ('share_edit_email_input_tooltip' | ppTranslate)"
    >
    <div class="inputWrapper" [class.inputWrapper--disabled]="ppDisabled">
      @if (!ppDisabled) {
        <input
          #shareModalEmailInput
          id="shareModalEmailInput"
          class="modalInput__input input share__email-input"
          [class.share__email-input--hidden]="!focused && emailList.length > 0"
          name="email"
          type="text"
          [placeholder]="'email_address' | ppTranslate"
          (keyup)="onEmailChange()"
          (change)="onEmailChange()"
          (ppOnRendered)="onInputRendered($event)"
          [(ngModel)]="emailInput"
          (focus)="onFocus()"
          (blur)="onBlur()"
          (keydown.enter)="blurInput($event)"
          autocomplete="off"
          />
      }

      @if (!focused) {
        <div class="userChips">
          @for (email of emailList; track email; let index = $index) {
            <pp-user-chip
              [ppDisabled]="ppDisabled"
              [ppEmail]="email"
              [ppHasError]="checkEmailError(email, index)"
              (ppRemoveUserCallback)="removeEmailFromList(index)"
            ></pp-user-chip>
          }
        </div>
      }
    </div>
  </div>
</div>
